import React from 'react';
import { Video, Check, User, Mail } from 'lucide-react';

const WebinarMagnet = () => (
  <section className="py-16 md:py-20 bg-white border-t border-green-100">
    <div className="max-w-2xl mx-auto px-4 md:px-6">
      {/* Problem Heading */}
      <div className="text-center mb-4">
        <h1 className="text-3xl md:text-5xl font-extrabold text-green-800 mb-3">Double Your Revenue Without Burnout: Join Our Free Webinar!</h1>
        <p className="text-lg md:text-2xl text-green-600 mb-6">Learn how to scale your wellness business sustainably—no more overwhelm or late nights.</p>
      </div>
      {/* Inviting Image */}
      <div className="flex justify-center mb-8">
        <img src="https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=600&q=80" alt="Webinar" className="rounded-xl shadow-lg w-full max-w-md object-cover" />
      </div>
      {/* Offer Section */}
      <div className="bg-green-50 rounded-xl shadow-lg overflow-hidden mb-10 md:mb-14">
        <div className="p-6 md:p-8 flex flex-col items-center">
          <Video className="w-10 h-10 text-green-400 mb-4" strokeWidth={1.5} />
          <h3 className="text-xl font-bold text-green-800 mb-2">What You'll Learn</h3>
          <ul className="mt-4 space-y-2 text-left">
            <li className="flex items-start">
              <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-green-700 text-sm">How to automate your business and reclaim your time</span>
            </li>
            <li className="flex items-start">
              <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-green-700 text-sm">Live Q&A with Kinos experts</span>
            </li>
            <li className="flex items-start">
              <Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-green-700 text-sm">Free resources for attendees</span>
            </li>
          </ul>
        </div>
      </div>
      {/* Form Section */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-10">
        <h4 className="text-lg font-semibold text-green-800 mb-4">Reserve Your Spot</h4>
        <form className="flex flex-col gap-4">
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <User className="w-5 h-5 text-green-400 mr-2" />
            <input type="text" placeholder="First Name" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <Mail className="w-5 h-5 text-green-400 mr-2" />
            <input type="email" placeholder="Email Address" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <button type="submit" className="mt-2 px-6 py-3 bg-green-400 text-white text-lg font-bold rounded-lg shadow-lg hover:bg-green-500 transition duration-300">
            Reserve My Spot
          </button>
        </form>
      </div>
      {/* Testimonials Section */}
      <div className="mt-12">
        <h4 className="text-xl font-bold text-green-800 mb-6 text-center">What Smart Coaches Are Saying</h4>
        <div className="relative">
          <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory scrollbar-hide">
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"This webinar showed me how to automate my business and finally take a real vacation!"</p>
                <span className="text-green-700 font-semibold">— Jordan P., Yoga Studio Owner</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"The strategies were actionable and the Q&A was super helpful. I feel less overwhelmed already."</p>
                <span className="text-green-700 font-semibold">— Casey L., Health Coach</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"I implemented just one tip from the webinar and my client onboarding time was cut in half. Can't wait for the next one!"</p>
                <span className="text-green-700 font-semibold">— Rachel M., Nutrition Consultant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WebinarMagnet; 